






































import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';

@Component({
  computed: {
    ...mapState(['Lang']),
  },
})
export default class StartRules extends Vue {}
